/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});


	// home page scripts only
	if ( jQuery('#home').length ) {

		//slider
		jQuery('.slider').unslider();

		//replace controls
		jQuery('.prev').each(function () {
			string = jQuery(this).text('Prev');
			var domain = document.domain;
			jQuery(this).html('<img src="wp-content/themes/Denali-Investigations/assets/images/prev.svg" alt="Prev" />');
		});
		jQuery('.next').each(function () {
			string = jQuery(this).text('Next');
			var domain = document.domain;
			jQuery(this).html('<img src="wp-content/themes/Denali-Investigations/assets/images/next.svg" alt="Next" />');
		});

		//hide form and internal divs
		jQuery('form').hide();
		jQuery('.form-section-2').hide();
		jQuery('.form-section-3').hide();
		jQuery('.description').hide();
		
		jQuery('#formToggle').click(function(){
			jQuery('form').toggle(800);
			//var y = jQuery(window).scrollTop();
			jQuery(window.opera ? 'html' : 'html, body').animate({
			scrollTop: 650
			},1000);// for 1 second
		});
		//toggle for client info
		jQuery('.client-info').click(function(){
			jQuery('.form-section-1').toggle(800);
		});
		jQuery('.subject-info').click(function(){
			jQuery('.form-section-2').toggle(800);
		});
		jQuery('.assignment-details').click(function(){
			jQuery('.form-section-3').toggle(800);
		});
		
		//toggling for services list
		var listToggle1 = 0;
		jQuery('.desc-title-one').click(function(){
			if (listToggle1 == 0) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				jQuery('.desc-title-one').addClass('active-state');
				jQuery('.desc-one').toggle(600);
				listToggle1 = 1;
				listToggle2 = 0;
				listToggle3 = 0;
				listToggle4 = 0;
				listToggle5 = 0;
				listToggle6 = 0;
				listToggle7 = 0;
				listToggle8 = 0;
			}
			else if (listToggle1 == 1) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				listToggle1 = 0;
			}
		});
		var listToggle2 = 0;
		jQuery('.desc-title-two').click(function(){
			if (listToggle2 == 0) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				jQuery('.desc-title-two').addClass('active-state');
				jQuery('.desc-two').toggle(600);
				listToggle1 = 0;
				listToggle2 = 1;
				listToggle3 = 0;
				listToggle4 = 0;
				listToggle5 = 0;
				listToggle6 = 0;
				listToggle7 = 0;
				listToggle8 = 0;
			}
			else if (listToggle2 == 1) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				listToggle2 = 0;
			}
		});
		var listToggle3 = 0;
		jQuery('.desc-title-three').click(function(){
			if (listToggle3 == 0) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				jQuery('.desc-title-three').addClass('active-state');
				jQuery('.desc-three').toggle(600);
				listToggle1 = 0;
				listToggle2 = 0;
				listToggle3 = 1;
				listToggle4 = 0;
				listToggle5 = 0;
				listToggle6 = 0;
				listToggle7 = 0;
				listToggle8 = 0;
			}
			else if (listToggle3 == 1) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				listToggle3 = 0;
			}
		});
		var listToggle4 = 0;
		jQuery('.desc-title-four').click(function(){
			if (listToggle4 == 0) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				jQuery('.desc-title-four').addClass('active-state');
				jQuery('.desc-four').toggle(600);
				listToggle1 = 0;
				listToggle2 = 0;
				listToggle3 = 0;
				listToggle4 = 1;
				listToggle5 = 0;
				listToggle6 = 0;
				listToggle7 = 0;
				listToggle8 = 0;
			}
			else if (listToggle4 == 1) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				listToggle4 = 0;
			}
		});
		var listToggle5 = 0;
		jQuery('.desc-title-five').click(function(){
			if (listToggle5 == 0) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				jQuery('.desc-title-five').addClass('active-state');
				jQuery('.desc-five').toggle(600);
				listToggle1 = 0;
				listToggle2 = 0;
				listToggle3 = 0;
				listToggle4 = 0;
				listToggle5 = 1;
				listToggle6 = 0;
				listToggle7 = 0;
				listToggle8 = 0;
			}
			else if (listToggle5 == 1) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				listToggle5 = 0;
			}
		});
		var listToggle6 = 0;
		jQuery('.desc-title-six').click(function(){
			if (listToggle6 == 0) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				jQuery('.desc-title-six').addClass('active-state');
				jQuery('.desc-six').toggle(600);
				listToggle1 = 0;
				listToggle2 = 0;
				listToggle3 = 0;
				listToggle4 = 0;
				listToggle5 = 0;
				listToggle6 = 1;
				listToggle7 = 0;
				listToggle8 = 0;
			}
			else if (listToggle6 == 1) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				listToggle6 = 0;
			}
		});
		var listToggle7 = 0;
		jQuery('.desc-title-seven').click(function(){
			if (listToggle7 == 0) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				jQuery('.desc-title-seven').addClass('active-state');
				jQuery('.desc-seven').toggle(600);
				listToggle1 = 0;
				listToggle2 = 0;
				listToggle3 = 0;
				listToggle4 = 0;
				listToggle5 = 0;
				listToggle6 = 0;
				listToggle7 = 1;
				listToggle8 = 0;
			}
			else if (listToggle7 == 1) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				listToggle7 = 0;
			}
		});
		var listToggle8 = 0;
		jQuery('.desc-title-eight').click(function(){
			if (listToggle8 == 0) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				jQuery('.desc-title-eight').addClass('active-state');
				jQuery('.desc-eight').toggle(600);
				listToggle1 = 0;
				listToggle2 = 0;
				listToggle3 = 0;
				listToggle4 = 0;
				listToggle5 = 0;
				listToggle6 = 0;
				listToggle7 = 0;
				listToggle8 = 1;
			}
			else if (listToggle8 == 1) {
				jQuery('.desc-title').removeClass('active-state');
				jQuery('.description').hide(600);
				listToggle8 = 0;
			}
		});
	}
}); 